import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FcmRegistrationService {
  async registerBrowserToken(): Promise<void> {
    return Promise.resolve();
  }

  async unregisterBrowserToken(): Promise<void> {
    return Promise.resolve();
  }
}
